@if (irosNotice) {
  <div class="bg-gray-light">
    <section class="min-h-1" ngClass.gt-xs="p-t-15 p-b-15" ngClass.xs="p-t-14 p-b-5">
      <div ngClass.gt-xs="p-h-10 cursor p-t-15" ngClass.xs="p-h-20">
        <div (click)="openNotice(irosNotice!)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">
            @if (irosNotice.isInspectionTime()) {
              <div class="notice-badge">
              공지사항
              </div>
            } @else {
              <div class="notice-badge bg-accent">
              점검 예정
              </div>
            }
          <div ngClass.gt-xs="f-14 f-w-650 lh-1-7" ngClass.xs="f-13 f-w-700">
            @if (irosNotice.isInspectionTime()) {
              {{ irosNotice.title }}
            } @else {
              인터넷등기소 점검으로 일부 서비스 중단 예정
            }
            <span fxShow.gt-xs fxHide ngClass.gt-xs="p-l-10" ngClass.xs="f-w-700">
              @if (isMobile) {
                <br/>
              }
              기간ㅣ{{ irosNotice.startAt | date: 'yyyy.MM.dd. HH : mm' }}
              - {{ irosNotice.endAt | date: 'MM.dd. HH : mm' }}
              </span>
          </div>
        </div>
      </div>
    </section>
  </div>
}

@if (analysisNotice) {
  <div class="bg-gray-light">
    <section class="min-h-1" ngClass.gt-xs="p-t-15 p-b-15" ngClass.xs="p-t-14 p-b-5">
      <div ngClass.gt-xs="p-h-10 cursor p-t-15" ngClass.xs="p-h-20">
        <div (click)="openNotice(analysisNotice!)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">
          <div class="notice-badge">공지사항</div>
          <div ngClass.gt-xs="f-14 f-w-650 lh-1-7" ngClass.xs="f-12 f-w-700">
            {{ analysisNotice.title }}
            <span fxShow.gt-xs fxHide ngClass.gt-xs="p-l-10" ngClass.xs="f-w-700">
              @if (isMobile) {
                <br/>
              }
              기간ㅣ{{ analysisNotice.startAt | date: 'yyyy.MM.dd. HH : mm' }}
              @if (analysisNotice.endAt) {
                - {{ analysisNotice.endAt | date: 'MM.dd. HH : mm' }}
              }
              </span>
          </div>
        </div>
      </div>
    </section>
  </div>
}
